<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	//import Buttons from './Buttons.vue'
	import Profit from './Profit'
	import Navbar from './Navbar'
	import Detail from './Detail'

	export default {
		props: ['user', 'isAuth'],
		components: {
			//'buttons': Buttons,
			'profit': Profit,
			'navbar': Navbar,
			'detail': Detail,
		},
		data () {
			return {
				data: null,
				term_and_conditions: null,
				account: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getTermAndConditions()
			},
			reloadData() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/budgets/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
					this.checkTax()
				}).catch(function(response) {
					console.log(response)
				})
			},
			checkTax() {
				if(this.data) {
					if(this.data.tax) {
						this.getAccount()
					}
				}
			},
			getAccount() {
				this.$http.get('admin/management/collection/account/first')
				.then(response => {
					this.account = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getTermAndConditions() {
				this.$http.get('admin/management/terms/conditions/get/budget')
				.then(response => {
					this.term_and_conditions = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Show.vue